module.exports = __webpack_public_path__ + "static/img/y55.5a75159.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y55.jpg
// module id = LJDi
// module chunks = 1